import { _ } from '../../../../vendor'
import InboomaBaseView from '../../InboomaBaseView'

import SalesBillingsSidebarTpl from '../../../templates/orders/SalesBillings/SalesBillingsSidebarTpl.html'

// @todo If any kind of filter shall be used, add SidebarFilterBehavior
// as e.g. in OrdersSidebarView.js
export default InboomaBaseView.extend({

    template : SalesBillingsSidebarTpl,
    el : '#inb-c-sidebar',

    templateContext () {
        return {
            _,
        }
    },


    initialize () {
        this.render()
    },

    _toggleLeftBar () {
        // unused as no filters there

        this.$el.toggleClass('open');

    }
});